module.exports = require("svg-to-pdfkit");